module.exports = __webpack_public_path__ + "img/icon-tooltip.c5d40828.svg";